﻿/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { VentaRespuesta, Page } from '../_models';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    getAllVentas() {
        return this.http.get<VentaRespuesta>(environment.apiUrl + '/api/v1/ventas');
    }

    getVentas(page: Page) {
        return this.http.get<VentaRespuesta>(environment.apiUrl + '/api/v1/ventas?rangoRegistros=' + page.from + '..' + page.to);
    }
}
